/**
 * The "Architect / Designer" lead source, and the name field it reveals.
 *
 * Matched on the stored value rather than the display label — unlike
 * `lead-source-other-referral.ts`, which has to match labels because the
 * sources it covers ("Other …") are a family rather than one member. A label
 * match would break here the moment the option is translated or the backend
 * relabels it.
 */
export const LEAD_SOURCE_ARCHITECT = "architect_designer"

export const ARCHITECT_NAME_MAX_LENGTH = 255

export function isLeadSourceArchitect(
  sourceValue: string | null | undefined
): boolean {
  return sourceValue === LEAD_SOURCE_ARCHITECT
}
